import styles from './styles.module.scss';
import { PropsWithChildren, memo } from 'react';
import GameDetailsWinFilter from '../../Filter/Tabs';
import { gameDetailsPeriodFilterOptions } from '../../Filter/Tabs/options';
import { GameDetailsContentRendererContentProps } from './props';

function GameDetailsContentRendererContent({
  children,
  currentOption,
  onOptionClick,
  isNoData,
}: PropsWithChildren<GameDetailsContentRendererContentProps>) {
  return (
    <div className={styles.container}>
      <GameDetailsWinFilter
        currentOption={currentOption}
        onOptionClick={onOptionClick}
        options={gameDetailsPeriodFilterOptions}
      />
      <div
        className={`${styles.container__content} ${
          isNoData ? styles.container__noData : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
}
export default memo(GameDetailsContentRendererContent);
